import { useEffect } from "react";
import { Box, Input as ThemeUiInput } from "theme-ui";
import camelCase from "lodash/camelCase";
import isNil from "lodash/isNil";

import { InfoButton } from "components";
import { CheckmarkIcon } from "components/icons";

export default function Checkbox({
  size = "small", // medium | small
  value,
  onChange = () => {},
  checkedValue = true,
  uncheckedValue = false,
  isDisabled,
  defaultValue,
  children,
  displayInfo,

  applyDisabledDefaultValue = true,
}) {
  const variantName = camelCase(["checkbox", size].filter(Boolean).join("-"));

  const isChecked = value === checkedValue;

  const handleChange = () => {
    onChange(isChecked ? uncheckedValue : checkedValue);
  };

  useEffect(() => {
    if (!isDisabled && isNil(value) && !isNil(defaultValue)) {
      onChange(defaultValue);
    }

    if (isDisabled && !defaultValue && applyDisabledDefaultValue) {
      onChange(defaultValue);
    }
  }, [isDisabled, value, defaultValue, applyDisabledDefaultValue]);

  return (
    <Box
      sx={{
        label: {
          color: "unset",
          fontFamily: "unset",
          fontSize: "unset",
          letterSpacing: "unset",
          lineHeight: "unset",
          textAlign: "unset",
          wordWrap: "break-word",
          whiteSpace: "nowrap",

          variant: `forms.${variantName}`,
        },
      }}
    >
      <Box as="label" disabled={isDisabled}>
        <Box className="checkbox">
          <ThemeUiInput
            type="checkbox"
            onChange={handleChange}
            checked={isChecked}
            disabled={isDisabled}
          />
          <CheckmarkIcon />
        </Box>
        {children && <Box className="label">{children}</Box>}
        {displayInfo && <InfoButton onClick={displayInfo}></InfoButton>}
      </Box>
    </Box>
  );
}
